import React from 'react'
import styled from 'styled-components'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import contactsImg from '../assets/contacts-illustration.svg'
import { FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa'
import { BsClockFill } from 'react-icons/bs'
import { MdAlternateEmail } from 'react-icons/md'
import ContactForm from '../components/ContactForm'
import OpacityAnimation from '../components/OpacityAnimation'

const ContactsPage = () => {

  return (
    <Wrapper>
        <OpacityAnimation>
            <MDBContainer>
                {/* ************************* IMAGE ************************ */}
                <MDBRow className="py-4 contactos-image">
                  <img src={contactsImg} alt="contactos" className="img-fluid"/>
                </MDBRow>
                {/* ************************* CONTACTS INFO************************ */}
                <MDBRow className="pt-4 gx-5">
                      <MDBCol md="12" lg="6" className="my-4">
                          {/* *************** CONSULTÓRIOS ************* */}
                          <section className="mb-4">
                            <div className="contacts-title d-flex flex-center">
                              <FaMapMarkerAlt />
                              <h3 className="font-weight-bold">Consultórios</h3>
                            </div>
                            <hr className="mb-2"/>
                            <p><span className="font-weight-bold">Rua Lino de Assunção 24</span><br />
                                2770-177 Paço de Arcos
                            </p>
                            <p><span className="font-weight-bold">Amoreiras - TORRE 1, piso 3, sala 10</span><br />
                              1070-101 Lisboa
                            </p>
                          </section>

                          {/* *************** HORÁRIOS ************* */}
                          <section className="mb-4">
                            <div className="contacts-title d-flex flex-center">
                              <BsClockFill />
                              <h3 className="font-weight-bold">Horários</h3>
                            </div>
                            <hr className="mb-2"/>
                            <p className="font-weight-bold">2ª a 6ª das 8h00 às 20h00</p>
                          </section>

                          {/* *************** EMAIL ************* */}
                          <section className="mb-4">
                            <div className="contacts-title d-flex flex-center">
                              <MdAlternateEmail />
                              <h3 className="font-weight-bold">Email</h3>
                            </div>
                            <hr className="mb-2"/>
                            <p className="font-weight-bold">tacoenjessica@gmail.com</p>
                          </section>

                          {/* *************** TELEFONE ************* */}
                          <section className="mb-4">
                            <div className="contacts-title d-flex flex-center">
                              <FaPhoneAlt />
                              <h3 className="font-weight-bold">Telefone</h3>
                            </div>
                            <hr className="mb-2"/>
                            <p className="font-weight-bold">+351 914373460</p>
                          </section> 
                      </MDBCol>
                      {/* ************************* FORM ************************ */}
                      <MDBCol md="12" lg="6" className="my-4 flex-fill d-flex align-items-center">
                            <ContactForm />
                      </MDBCol>
                </MDBRow>
            </MDBContainer>
        </OpacityAnimation>
    </Wrapper>
  )
}
const Wrapper = styled.section`
      margin-top: 8rem;
      margin-bottom: 8rem;
      background: var(--clr-grey-9);
      .contactos-image {
        img {
          max-height: 400px
        }
      }

      .contacts-title {
          color: var(--website-main-color);
          svg {
            font-size: 2rem; 
            margin-right: 0.8rem;
          }
      }
`


export default ContactsPage
